var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"home-layout"}},[_vm._t("default"),_c('Alert',{attrs:{"snackbar":_vm.snackbar,"type":_vm.alertType,"text":_vm.alertText}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }